import { type HTMLAttributes, forwardRef } from 'react'
import { twMerge } from 'tailwind-merge'
import { Progress } from '@/components/base/Progress'
import { ProgressInfoRow } from './ProgressInfoRow'
import { ProgressLabel } from './ProgressLabel'
import { ProgressValueText } from './ProgressValueText'

export interface ProgressBarWithInfoProps extends HTMLAttributes<HTMLDivElement> {
  value: number
  max?: number
  accentColor?: 'none' | 'yellow' | 'green' | 'blue' | 'pink'
  label?: React.ReactNode | ((value: number, max: number) => React.ReactNode)
  valueText?: React.ReactNode | ((value: number, max: number) => React.ReactNode)
}

export const ProgressBarWithInfo = forwardRef<HTMLDivElement, ProgressBarWithInfoProps>(
  ({ value, max = 100, accentColor = 'none', label, valueText, className, ...props }, ref) => {
    const resolvedLabel = typeof label === 'function' ? label(value, max) : label
    const resolvedValue = typeof valueText === 'function' ? valueText(value, max) : valueText

    return (
      <div className={twMerge('flex flex-col gap-1', className)} ref={ref} {...props}>
        <Progress accentColor={accentColor} max={max} value={value} />
        {resolvedLabel || resolvedValue ? (
          <ProgressInfoRow>
            {resolvedLabel ? <ProgressLabel>{resolvedLabel}</ProgressLabel> : null}
            {resolvedValue ? <ProgressValueText>{resolvedValue}</ProgressValueText> : null}
          </ProgressInfoRow>
        ) : null}
      </div>
    )
  }
)

ProgressBarWithInfo.displayName = 'ProgressBarWithInfo'
